import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'template/byType';

export interface ITemplatesByQueryParams {
	enabled?: boolean;
	forUserId?: string;
	userId?: string;
	type: Api.TemplateType;
	pageSize?: number;
	impersonationContext?: Api.IImpersonationContext;
	includeNonUserTemplates?: boolean;
	onError?: (err: Api.IOperationResultNoValue) => void;
	meta?: LevStandardQueryMeta;
}

export function useTemplatesByType({
	enabled,
	forUserId,
	userId,
	type,
	pageSize = 25,
	impersonationContext,
	includeNonUserTemplates,
	meta,
}: ITemplatesByQueryParams) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		meta,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ITemplate>>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'template/byType',
					impersonationContext,
					queryParams: {
						forUserId,
						type,
						pageSize,
						userId,
						pageToken: pageParam,
						includeNonUserTemplates,
					},
				}),
				'GET'
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		queryKey: [BASE_QUERY_KEY, type, pageSize, userId, forUserId, impersonationContext],
		initialPageParam: '',
	});
}

export function invalidateAllTemplatesByTypeQuery() {
	return reactQueryClient.invalidateQueries({
		queryKey: [BASE_QUERY_KEY],
	});
}
